import { Button } from "../ui/button"
import { FadeIn } from "../ui/fade-in"
import { ShineBorder } from "../ui/shine-border"
import { Mail, Phone, MapPin, Send } from "lucide-react"

export function ContactSection() {
  return (
    <section id="contact" className="py-24 bg-black relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 to-black"></div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-600/50 to-transparent"></div>

      {/* Red accent */}
      <div className="absolute right-0 top-1/4 h-32 w-1 bg-red-600"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn direction="up">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Contactez <span className="text-red-600">Nous</span>
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Prêt à sécuriser votre entreprise? Notre équipe d'experts est là pour vous aider.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12">
          <FadeIn direction="right">
            <ShineBorder className="h-full" borderClassName="border border-white/10 rounded-xl">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 md:p-8 h-full">
                <h3 className="text-2xl font-semibold mb-6">Envoyez-nous un message</h3>

                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-1">
                        Nom
                      </label>
                      <input
                        type="text"
                        id="name"
                        className="w-full px-4 py-2 bg-black/50 border border-white/10 rounded-md focus:outline-none focus:ring-1 focus:ring-red-600"
                        placeholder="Votre nom"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="w-full px-4 py-2 bg-black/50 border border-white/10 rounded-md focus:outline-none focus:ring-1 focus:ring-red-600"
                        placeholder="votre@email.com"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-300 mb-1">
                      Sujet
                    </label>
                    <input
                      type="text"
                      id="subject"
                      className="w-full px-4 py-2 bg-black/50 border border-white/10 rounded-md focus:outline-none focus:ring-1 focus:ring-red-600"
                      placeholder="Comment pouvons-nous vous aider?"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-1">
                      Message
                    </label>
                    <textarea
                      id="message"
                      rows={4}
                      className="w-full px-4 py-2 bg-black/50 border border-white/10 rounded-md focus:outline-none focus:ring-1 focus:ring-red-600"
                      placeholder="Votre message..."
                    ></textarea>
                  </div>

                  <Button variant="primary" className="w-full flex items-center justify-center gap-2">
                    <Send className="w-4 h-4" />
                    Envoyer le message
                  </Button>
                </form>
              </div>
            </ShineBorder>
          </FadeIn>

          <FadeIn direction="left">
            <div className="space-y-8">
              <ShineBorder borderClassName="border border-white/10 rounded-xl">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 md:p-8">
                  <h3 className="text-2xl font-semibold mb-6">Informations de contact</h3>

                  <div className="space-y-6">
                    <div className="flex items-start gap-4">
                      <div className="bg-red-600/10 p-3 rounded-full">
                        <Mail className="w-6 h-6 text-red-600" />
                      </div>
                      <div>
                        <h4 className="text-lg font-medium mb-1">Email</h4>
                        <p className="text-gray-400">contact@sm-security.com</p>
                        <p className="text-gray-400">support@sm-security.com</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="bg-red-600/10 p-3 rounded-full">
                        <Phone className="w-6 h-6 text-red-600" />
                      </div>
                      <div>
                        <h4 className="text-lg font-medium mb-1">Téléphone</h4>
                        <p className="text-gray-400">+33 (0)1 23 45 67 89</p>
                        <p className="text-gray-400">+33 (0)6 12 34 56 78</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="bg-red-600/10 p-3 rounded-full">
                        <MapPin className="w-6 h-6 text-red-600" />
                      </div>
                      <div>
                        <h4 className="text-lg font-medium mb-1">Adresse</h4>
                        <p className="text-gray-400">
                          123 Avenue de la Cybersécurité
                          <br />
                          75008 Paris, France
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ShineBorder>

              <ShineBorder borderClassName="border border-white/10 rounded-xl">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 md:p-8">
                  <h3 className="text-xl font-semibold mb-4">Heures d'ouverture</h3>
                  <div className="space-y-2 text-gray-400">
                    <div className="flex justify-between">
                      <span>Lundi - Vendredi:</span>
                      <span>9:00 - 18:00</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Samedi:</span>
                      <span>10:00 - 15:00</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Dimanche:</span>
                      <span>Fermé</span>
                    </div>
                  </div>

                  <div className="mt-6 pt-6 border-t border-white/10">
                    <h4 className="text-lg font-medium mb-2">Support d'urgence</h4>
                    <p className="text-gray-400">
                      Notre équipe de support d'urgence est disponible 24/7 pour nos clients sous contrat.
                    </p>
                  </div>
                </div>
              </ShineBorder>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  )
}
